module.exports = __webpack_public_path__ + "img/C00021.67f8ade9.png";